// import React, { useState, useEffect, useRef } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Checkbox,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   TablePagination,
//   CircularProgress,
//   IconButton,
//   InputAdornment,
//   Alert,
// } from "@mui/material";
// import { Search, Close } from "@mui/icons-material";
// import axios from "axios";
// import { BASE_URL } from "../../../../services/configUrls";

// const AddFacultyModal = ({ open, onClose, bookslotId, onSuccess }) => {
//   const [facultyList, setFacultyList] = useState([]);
//   const [filteredFacultyList, setFilteredFacultyList] = useState([]);
//   const [selectedFaculty, setSelectedFaculty] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState(null);

//   // Ref to prevent duplicate submissions
//   const isSubmittingRef = useRef(false);

//   // Filters
//   const [searchQuery, setSearchQuery] = useState("");
//   const [designationFilter, setDesignationFilter] = useState("");
//   const [branchFilter, setBranchFilter] = useState("");

//   // Pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Get unique designations and branches for filters
//   const uniqueDesignations = [
//     ...new Set(facultyList.map((f) => f.designation).filter(Boolean)),
//   ];
//   const uniqueBranches = [
//     ...new Set(facultyList.map((f) => f.branch).filter(Boolean)),
//   ];

//   // Fetch faculty list when modal opens
//   useEffect(() => {
//     if (open) {
//       fetchFacultyList();
//       // Reset states when modal opens
//       setSelectedFaculty([]);
//       setSearchQuery("");
//       setDesignationFilter("");
//       setBranchFilter("");
//       setPage(0);
//       isSubmittingRef.current = false;
//     }
//   }, [open]);

//   // Apply filters whenever filter values change
//   useEffect(() => {
//     let filtered = [...facultyList];

//     // Search filter (name, email, phone)
//     if (searchQuery.trim()) {
//       const query = searchQuery.toLowerCase();
//       filtered = filtered.filter(
//         (faculty) =>
//           faculty.name.toLowerCase().includes(query) ||
//           faculty.email.toLowerCase().includes(query) ||
//           faculty.phone_no.includes(query)
//       );
//     }

//     // Designation filter
//     if (designationFilter) {
//       filtered = filtered.filter(
//         (faculty) => faculty.designation === designationFilter
//       );
//     }

//     // Branch filter
//     if (branchFilter) {
//       filtered = filtered.filter((faculty) => faculty.branch === branchFilter);
//     }

//     setFilteredFacultyList(filtered);
//     setPage(0); // Reset to first page when filters change
//   }, [facultyList, searchQuery, designationFilter, branchFilter]);

//   const fetchFacultyList = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(`${BASE_URL}/event/faculty-list`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });

//       if (response.data && response.data.data) {
//         setFacultyList(response.data.data);
//       }
//     } catch (err) {
//       setError("Failed to fetch faculty list. Please try again.");
//       console.error("Error fetching faculty list:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSelectFaculty = (faculty) => {
//     const isSelected = selectedFaculty.some(
//       (f) => f.faculty_id === faculty.faculty_id && f.email === faculty.email
//     );

//     if (isSelected) {
//       setSelectedFaculty(
//         selectedFaculty.filter(
//           (f) =>
//             !(f.faculty_id === faculty.faculty_id && f.email === faculty.email)
//         )
//       );
//     } else {
//       setSelectedFaculty([...selectedFaculty, faculty]);
//     }
//   };

//   const handleSelectAll = (event) => {
//     if (event.target.checked) {
//       const currentPageFaculty = paginatedFaculty();
//       const newSelections = [...selectedFaculty];

//       currentPageFaculty.forEach((faculty) => {
//         const isAlreadySelected = newSelections.some(
//           (f) =>
//             f.faculty_id === faculty.faculty_id && f.email === faculty.email
//         );
//         if (!isAlreadySelected) {
//           newSelections.push(faculty);
//         }
//       });

//       setSelectedFaculty(newSelections);
//     } else {
//       const currentPageFaculty = paginatedFaculty();
//       setSelectedFaculty(
//         selectedFaculty.filter(
//           (selected) =>
//             !currentPageFaculty.some(
//               (current) =>
//                 current.faculty_id === selected.faculty_id &&
//                 current.email === selected.email
//             )
//         )
//       );
//     }
//   };

//   const isFacultySelected = (faculty) => {
//     return selectedFaculty.some(
//       (f) => f.faculty_id === faculty.faculty_id && f.email === faculty.email
//     );
//   };

//   const isAllSelected = () => {
//     const currentPageFaculty = paginatedFaculty();
//     return (
//       currentPageFaculty.length > 0 &&
//       currentPageFaculty.every((faculty) => isFacultySelected(faculty))
//     );
//   };

//   const paginatedFaculty = () => {
//     const startIndex = page * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     return filteredFacultyList.slice(startIndex, endIndex);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleSubmit = async () => {
//     if (selectedFaculty.length === 0) {
//       setError("Please select at least one faculty member.");
//       return;
//     }

//     // Prevent duplicate submissions
//     if (isSubmittingRef.current || submitting) {
//       console.log("Submission already in progress, ignoring duplicate call");
//       return;
//     }

//     isSubmittingRef.current = true;
//     setSubmitting(true);
//     setError(null);

//     try {
//       // Extract faculty IDs from selected faculty
//       const facultyIds = selectedFaculty.map((faculty) => faculty.faculty_id);

//       // Single API call with all faculty IDs
//       const response = await axios.post(
//         `${BASE_URL}/event/add-faculty-to-bookslot`,
//         {
//           bookslot_id: bookslotId,
//           faculty_ids: facultyIds,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );

//       // Extract text from HTML response
//       const htmlContent = response.data.detail || "Faculty added successfully!";
//       const tempDiv = document.createElement("div");
//       tempDiv.innerHTML = htmlContent;
//       const textContent =
//         tempDiv.textContent || tempDiv.innerText || htmlContent;

//       // Show alert with the message
//       alert(textContent.trim());

//       // Call onSuccess callback if provided
//       if (onSuccess) {
//         onSuccess();
//       }

//       // Close modal
//       handleClose();
//     } catch (err) {
//       setError(
//         err?.response?.data?.detail ||
//           "Failed to add faculty. Please try again."
//       );
//       // console.error("Error adding faculty:", err.response.data.detail);
//     } finally {
//       setSubmitting(false);
//       isSubmittingRef.current = false;
//     }
//   };

//   const handleClose = () => {
//     if (!submitting) {
//       onClose();
//       // Reset states
//       setSelectedFaculty([]);
//       setSearchQuery("");
//       setDesignationFilter("");
//       setBranchFilter("");
//       setError(null);
//       setPage(0);
//       isSubmittingRef.current = false;
//     }
//   };

//   const clearFilters = () => {
//     setSearchQuery("");
//     setDesignationFilter("");
//     setBranchFilter("");
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 2,
//             minHeight: "60vh",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             borderBottom: "1px solid #e0e0e0",
//             pb: 2,
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6" component="div">
//             Add Faculty Members
//           </Typography>
//           <IconButton
//             onClick={handleClose}
//             disabled={submitting}
//             size="small"
//             sx={{ color: "text.secondary" }}
//           >
//             <Close />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ pt: 3 }}>
//           {/* Filters Section */}
//           <Box sx={{ mb: 3 }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 2,
//                 flexWrap: "wrap",
//                 alignItems: "center",
//                 mb: 2,
//               }}
//             >
//               {/* Search Bar */}
//               <TextField
//                 placeholder="Search by name, email, or phone"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 size="small"
//                 sx={{ flexGrow: 1, minWidth: "250px" }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Search fontSize="small" />
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               {/* Designation Filter */}
//               <FormControl size="small" sx={{ minWidth: 150 }}>
//                 <InputLabel>Designation</InputLabel>
//                 <Select
//                   value={designationFilter}
//                   onChange={(e) => setDesignationFilter(e.target.value)}
//                   label="Designation"
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {uniqueDesignations.map((designation) => (
//                     <MenuItem key={designation} value={designation}>
//                       {designation}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {/* Branch Filter */}
//               <FormControl size="small" sx={{ minWidth: 150 }}>
//                 <InputLabel>Branch</InputLabel>
//                 <Select
//                   value={branchFilter}
//                   onChange={(e) => setBranchFilter(e.target.value)}
//                   label="Branch"
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {uniqueBranches.map((branch) => (
//                     <MenuItem key={branch} value={branch}>
//                       {branch}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {/* Clear Filters Button */}
//               {(searchQuery || designationFilter || branchFilter) && (
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   onClick={clearFilters}
//                   sx={{ minWidth: "auto" }}
//                 >
//                   Clear Filters
//                 </Button>
//               )}
//             </Box>

//             {/* Selected Count */}
//             {selectedFaculty.length > 0 && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography variant="body2" color="primary">
//                   {selectedFaculty.length} faculty member(s) selected
//                 </Typography>
//               </Box>
//             )}
//           </Box>

//           {/* Error Message */}
//           {error && (
//             <Alert
//               severity="error"
//               sx={{ mb: 2 }}
//               onClose={() => setError(null)}
//             >
//               {error}
//             </Alert>
//           )}

//           {/* Loading State */}
//           {loading ? (
//             <Box
//               display="flex"
//               justifyContent="center"
//               alignItems="center"
//               minHeight="300px"
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               {/* Faculty Table */}
//               <TableContainer
//                 component={Paper}
//                 sx={{
//                   borderRadius: 2,
//                   border: "1px solid #e0e0e0",
//                   maxHeight: "400px",
//                 }}
//               >
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell padding="checkbox">
//                         <Checkbox
//                           indeterminate={
//                             selectedFaculty.length > 0 && !isAllSelected()
//                           }
//                           checked={isAllSelected()}
//                           onChange={handleSelectAll}
//                           disabled={paginatedFaculty().length === 0}
//                         />
//                       </TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>
//                         Designation
//                       </TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Branch</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {paginatedFaculty().length > 0 ? (
//                       paginatedFaculty().map((faculty, index) => (
//                         <TableRow
//                           key={`${faculty.faculty_id}-${faculty.email}-${index}`}
//                           hover
//                           onClick={() => handleSelectFaculty(faculty)}
//                           sx={{ cursor: "pointer" }}
//                         >
//                           <TableCell padding="checkbox">
//                             <Checkbox checked={isFacultySelected(faculty)} />
//                           </TableCell>
//                           <TableCell>{faculty.name}</TableCell>
//                           <TableCell>{faculty.email}</TableCell>
//                           <TableCell>{faculty.phone_no}</TableCell>
//                           <TableCell>{faculty.designation || "-"}</TableCell>
//                           <TableCell>{faculty.branch || "-"}</TableCell>
//                         </TableRow>
//                       ))
//                     ) : (
//                       <TableRow>
//                         <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
//                           <Typography color="text.secondary">
//                             {filteredFacultyList.length === 0
//                               ? searchQuery || designationFilter || branchFilter
//                                 ? "No faculty found matching your filters"
//                                 : "No faculty available"
//                               : "No results"}
//                           </Typography>
//                         </TableCell>
//                       </TableRow>
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               {/* Pagination */}
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 25, 50]}
//                 component="div"
//                 count={filteredFacultyList.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 sx={{ borderTop: "1px solid #e0e0e0" }}
//               />
//             </>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0" }}>
//           <Button
//             onClick={handleClose}
//             disabled={submitting}
//             variant="outlined"
//             color="inherit"
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSubmit}
//             disabled={submitting || selectedFaculty.length === 0}
//             variant="contained"
//             color="primary"
//           >
//             {submitting ? (
//               <>
//                 <CircularProgress size={20} sx={{ mr: 1 }} />
//                 Adding...
//               </>
//             ) : (
//               `Add ${
//                 selectedFaculty.length > 0 ? `(${selectedFaculty.length})` : ""
//               }`
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default AddFacultyModal;

import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
  TablePagination,
  CircularProgress,
  IconButton,
  InputAdornment,
  Alert,
  Chip,
  Skeleton,
  Grid,
  useMediaQuery,
  useTheme,
  Card,
} from "@mui/material";
import {
  Search,
  Close,
  Receipt,
  TrendingUp,
  AccountBalance,
  CheckCircle,
  PersonAdd,
  Payment,
  Group,
  CheckCircleOutline,
  HowToReg,
  Add,
  Remove,
} from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../../services/configUrls";
import AddNewFacultyModal from "./AddNewFacultyModal";

// Custom hook for Razorpay
const useRazorpay = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (window.Razorpay) {
      setIsLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => {
      setIsLoaded(true);
    };
    script.onerror = () => {
      setError("Failed to load Razorpay SDK. Please check your connection.");
      setIsLoaded(false);
    };
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return { isLoaded, error };
};

// Payment Preview Modal Component
const PaymentPreviewModal = ({
  open,
  onClose,
  onConfirm,
  paymentData,
  facultyCount,
  loading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!paymentData) return null;

  const { seller, buyer, place_of_supply, item, pricing, gst_label, date } =
    paymentData;

  const subTotal = pricing.rate_per_faculty * facultyCount;
  const gstAmount = subTotal * (pricing.gst_percentage / 100);
  const totalAmount = subTotal + gstAmount;

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "2px solid #1565C0",
          pb: 2,
          bgcolor: "#1565C0",
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Receipt sx={{ color: "white" }} />
          <Typography variant="h6" component="span" fontWeight="bold">
            Payment Summary
          </Typography>
        </Box>
        {!loading && (
          <IconButton onClick={onClose} size="small" sx={{ color: "white" }}>
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={{ pt: 3, mt: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              {seller.name}
            </Typography>
            <Typography variant="body2">{seller.address}</Typography>
            <Typography variant="body2">
              {seller.city}, {seller.state} - {seller.pincode}, {seller.country}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              GSTIN: {seller.gstin}
            </Typography>
            <Typography variant="body2">PAN: {seller.pan}</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Bill To
            </Typography>
            <Typography variant="body2" fontWeight="medium">
              {buyer.name}
            </Typography>
            {buyer.address && (
              <Typography variant="body2">{buyer.address}</Typography>
            )}
            <Typography variant="body2">
              {buyer.city}, {buyer.state}
              {buyer.pincode && `, ${buyer.pincode}`}, {buyer.country}
            </Typography>
            {buyer.gstin && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                GSTIN: {buyer.gstin}
              </Typography>
            )}

            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Date
              </Typography>
              <Typography variant="body2">{date}</Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Place of Supply: {place_of_supply}
            </Typography>
          </Grid>
        </Grid>

        <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 2 }}>
          <Table size={isMobile ? "small" : "medium"}>
            <TableHead>
              <TableRow sx={{ bgcolor: "#1565C0" }}>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                  Item & Description
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                  Unit
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  Rate
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  GST
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    {item.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {item.description}
                  </Typography>
                  <Typography variant="caption" display="block">
                    Validity: {item.validity}
                  </Typography>
                  <Typography variant="caption" display="block">
                    No. of Faculty: {facultyCount}
                  </Typography>
                </TableCell>
                <TableCell>{facultyCount} Faculty</TableCell>
                <TableCell align="right">
                  ₹{pricing.rate_per_faculty.toFixed(2)}
                </TableCell>
                <TableCell align="right">{pricing.gst_percentage}%</TableCell>
                <TableCell align="right">₹{subTotal.toFixed(2)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} align="right">
                  <Typography variant="body2" fontWeight="medium">
                    Sub Total
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" fontWeight="medium">
                    ₹{subTotal.toFixed(2)}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4} align="right">
                  <Typography variant="body2">{gst_label}</Typography>
                </TableCell>
                <TableCell align="right">₹{gstAmount.toFixed(2)}</TableCell>
              </TableRow>
              <TableRow sx={{ bgcolor: "#E3F2FD" }}>
                <TableCell colSpan={4} align="right">
                  <Typography variant="h6" fontWeight="bold">
                    Total
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="h6" fontWeight="bold" color="#1565C0">
                    ₹{totalAmount.toFixed(2)}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          gap: 1,
          flexDirection: { xs: "column-reverse", sm: "row" },
        }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          fullWidth={isMobile}
          sx={{
            order: { xs: 2, sm: 1 },
            borderColor: "#1565C0",
            color: "#1565C0",
            "&:hover": {
              borderColor: "#0D47A1",
              bgcolor: "rgba(21, 101, 192, 0.04)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
          fullWidth={isMobile}
          sx={{
            order: { xs: 1, sm: 2 },
            bgcolor: "#1565C0",
            "&:hover": { bgcolor: "#0D47A1" },
          }}
        >
          {loading
            ? "Processing..."
            : `Proceed to Pay ₹${totalAmount.toFixed(2)}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const AddFacultyModal = ({ open, onClose, bookslotId, onSuccess }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [facultyList, setFacultyList] = useState([]);
  const [filteredFacultyList, setFilteredFacultyList] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const [paymentInfo, setPaymentInfo] = useState(null);
  const [checkingPayment, setCheckingPayment] = useState(false);
  const [showPaymentPreview, setShowPaymentPreview] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);

  const [facultyCount, setFacultyCount] = useState(1);
  const [showFacultyList, setShowFacultyList] = useState(false);
  const [needsPayment, setNeedsPayment] = useState(false);

  const [showAddNewFacultyModal, setShowAddNewFacultyModal] = useState(false);

  const [paymentCaptured, setPaymentCaptured] = useState(false);
  const [facultyAdded, setFacultyAdded] = useState(false);

  const { isLoaded: razorpayLoaded, error: razorpayError } = useRazorpay();

  const isSubmittingRef = useRef(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [designationFilter, setDesignationFilter] = useState("");
  const [branchFilter, setBranchFilter] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const uniqueDesignations = [
    ...new Set(facultyList.map((f) => f.designation).filter(Boolean)),
  ];
  const uniqueBranches = [
    ...new Set(facultyList.map((f) => f.branch).filter(Boolean)),
  ];

  useEffect(() => {
    if (open) {
      checkPaymentRequirement();
      setFacultyCount(1);
      setShowFacultyList(false);
      setPaymentCompleted(false);
      setNeedsPayment(false);
      setSelectedFaculty([]);
      setSearchQuery("");
      setDesignationFilter("");
      setBranchFilter("");
      setPage(0);
      setError(null);
      setShowPaymentPreview(false);
      setPaymentCaptured(false);
      setFacultyAdded(false);
      isSubmittingRef.current = false;
    }
  }, [open, bookslotId]);

  useEffect(() => {
    if (razorpayError) {
      setError(razorpayError);
    }
  }, [razorpayError]);

  useEffect(() => {
    if (paymentInfo) {
      const facultyCountInfo = paymentInfo.faculty_count_info;
      const requiresPayment = paymentInfo.requires_payment;

      if (facultyCountInfo && facultyCountInfo.total_paid_slots >= 1) {
        setPaymentCaptured(true);
      }

      if (facultyCountInfo && facultyCountInfo.faculty_already_added > 0) {
        setFacultyAdded(true);
      }

      if (!requiresPayment) {
        setShowFacultyList(true);
        setNeedsPayment(false);
        fetchFacultyList();
      } else if (facultyCountInfo && facultyCountInfo.total_paid_slots >= 1) {
        setShowFacultyList(true);
        setNeedsPayment(false);
        fetchFacultyList();
      } else if (
        facultyCountInfo &&
        facultyCountInfo.remaining_paid_slots > 0
      ) {
        setShowFacultyList(true);
        setNeedsPayment(false);
        fetchFacultyList();
      } else if (facultyCountInfo && facultyCountInfo.can_pay_for_more > 0) {
        setShowFacultyList(false);
        setNeedsPayment(true);
      } else {
        setShowFacultyList(false);
        setNeedsPayment(false);
        setError("No faculty slots available. Please contact administrator.");
      }
    }
  }, [paymentInfo]);

  useEffect(() => {
    if (paymentCompleted && showFacultyList) {
      fetchFacultyList();
    }
  }, [paymentCompleted, showFacultyList]);

  useEffect(() => {
    let filtered = [...facultyList];

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (faculty) =>
          faculty.name.toLowerCase().includes(query) ||
          faculty.email.toLowerCase().includes(query) ||
          faculty.phone_no.includes(query),
      );
    }

    if (designationFilter) {
      filtered = filtered.filter(
        (faculty) => faculty.designation === designationFilter,
      );
    }

    if (branchFilter) {
      filtered = filtered.filter((faculty) => faculty.branch === branchFilter);
    }

    setFilteredFacultyList(filtered);
    setPage(0);
  }, [facultyList, searchQuery, designationFilter, branchFilter]);

  const fetchFacultyList = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${BASE_URL}/event/faculty-list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.data && response.data.data) {
        setFacultyList(response.data.data);
      }
    } catch (err) {
      setError("Failed to fetch faculty list. Please try again.");
      console.error("Error fetching faculty list:", err);
    } finally {
      setLoading(false);
    }
  };

  const checkPaymentRequirement = async () => {
    if (!bookslotId) return;
    setCheckingPayment(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/event/amount/${bookslotId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
      setPaymentInfo(response.data);
    } catch (err) {
      console.error("Error checking payment requirement:", err);
      setPaymentInfo({ requires_payment: false });
    } finally {
      setCheckingPayment(false);
    }
  };

  const handleSelectFaculty = (faculty) => {
    const isSelected = selectedFaculty.some(
      (f) => f.faculty_id === faculty.faculty_id && f.email === faculty.email,
    );

    const maxSelectable =
      paymentInfo?.faculty_count_info?.remaining_paid_slots ||
      paymentInfo?.faculty_count_info?.slots_available ||
      facultyCount;

    if (isSelected) {
      setSelectedFaculty(
        selectedFaculty.filter(
          (f) =>
            !(f.faculty_id === faculty.faculty_id && f.email === faculty.email),
        ),
      );
    } else {
      if (selectedFaculty.length >= maxSelectable) {
        setError(`You can only select ${maxSelectable} faculty members.`);
        return;
      }
      setSelectedFaculty([...selectedFaculty, faculty]);
    }
  };

  const handleSelectAll = (event) => {
    const maxSelectable =
      paymentInfo?.faculty_count_info?.remaining_paid_slots ||
      paymentInfo?.faculty_count_info?.slots_available ||
      facultyCount;

    if (event.target.checked) {
      const currentPageFaculty = paginatedFaculty();
      const newSelections = [...selectedFaculty];
      currentPageFaculty.forEach((faculty) => {
        const isAlreadySelected = newSelections.some(
          (f) =>
            f.faculty_id === faculty.faculty_id && f.email === faculty.email,
        );
        if (!isAlreadySelected && newSelections.length < maxSelectable) {
          newSelections.push(faculty);
        }
      });
      setSelectedFaculty(newSelections);
    } else {
      const currentPageFaculty = paginatedFaculty();
      setSelectedFaculty(
        selectedFaculty.filter(
          (selected) =>
            !currentPageFaculty.some(
              (current) =>
                current.faculty_id === selected.faculty_id &&
                current.email === selected.email,
            ),
        ),
      );
    }
  };

  const isFacultySelected = (faculty) => {
    return selectedFaculty.some(
      (f) => f.faculty_id === faculty.faculty_id && f.email === faculty.email,
    );
  };

  const isAllSelected = () => {
    const currentPageFaculty = paginatedFaculty();
    return (
      currentPageFaculty.length > 0 &&
      currentPageFaculty.every((faculty) => isFacultySelected(faculty))
    );
  };

  const paginatedFaculty = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredFacultyList.slice(startIndex, endIndex);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const generateIdempotencyKey = () => {
    return `faculty-${bookslotId}-${Date.now()}-${Math.random()
      .toString(36)
      .substring(7)}`;
  };

  const handlePayForMore = () => {
    setShowFacultyList(false);
    setNeedsPayment(true);
  };

  const handleShowPaymentPreview = () => {
    if (facultyCount < 1 || facultyCount > 60) {
      setError("Faculty count must be between 1 and 60.");
      return;
    }

    const canPayFor = paymentInfo?.faculty_count_info?.can_pay_for_more || 0;
    if (facultyCount > canPayFor) {
      setError(`You can only pay for up to ${canPayFor} more faculty members.`);
      return;
    }

    setShowPaymentPreview(true);
  };

  const handlePaymentFlow = async () => {
    if (!razorpayLoaded) {
      setError("Payment system is still loading. Please wait...");
      setShowPaymentPreview(false);
      return;
    }

    setSubmitting(true);
    setError(null);
    isSubmittingRef.current = true;

    try {
      const idempotencyKey = generateIdempotencyKey();
      const paymentResponse = await axios.post(
        `${BASE_URL}/event/initiate-and-verify`,
        {
          bookslot_id: bookslotId,
          faculty_count: facultyCount,
          idempotency_key: idempotencyKey,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      const paymentData = paymentResponse.data;
      setShowPaymentPreview(false);

      const razorpayOptions = {
        key: paymentData.razorpay_key_id,
        amount: parseFloat(paymentData.amount) * 100,
        currency: paymentData.currency,
        name: "EDP Faculty Nomination",
        description: `Payment for ${facultyCount} faculty member(s)`,
        order_id: paymentData.order_id,
        handler: async function (response) {
          console.log("Payment successful:", response);
          try {
            await axios.post(
              `${BASE_URL}/event/initiate-and-verify`,
              {
                bookslot_id: bookslotId,
                faculty_count: facultyCount,
                idempotency_key: idempotencyKey,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
              },
            );

            setPaymentCompleted(true);
            setPaymentCaptured(true);
            setShowFacultyList(true);
            setNeedsPayment(false);
            setSubmitting(false);
            isSubmittingRef.current = false;
            checkPaymentRequirement();
          } catch (err) {
            console.error("Error verifying payment:", err);
            setError("Payment successful. Please select faculty members.");
            setPaymentCaptured(true);
            setShowFacultyList(true);
            setNeedsPayment(false);
            setSubmitting(false);
            isSubmittingRef.current = false;
          }
        },
        prefill: {
          name: localStorage.getItem("userName") || "SPOC",
          email: localStorage.getItem("userEmail") || "",
          contact: localStorage.getItem("userPhone") || "",
        },
        theme: {
          color: "#1976d2",
        },
        modal: {
          ondismiss: function () {
            console.log("Payment cancelled by user");
            setSubmitting(false);
            isSubmittingRef.current = false;
            setError("Payment cancelled. Please try again.");
          },
        },
      };

      const razorpayInstance = new window.Razorpay(razorpayOptions);
      razorpayInstance.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        setSubmitting(false);
        isSubmittingRef.current = false;
        setError(`Payment failed: ${response.error.description}`);
      });
      razorpayInstance.open();
    } catch (err) {
      console.error("Error initiating payment:", err);
      setError(
        err?.response?.data?.detail ||
          "Failed to initiate payment. Please try again.",
      );
      setSubmitting(false);
      isSubmittingRef.current = false;
      setShowPaymentPreview(false);
    }
  };

  const handleAddFacultyToBookslot = async () => {
    if (selectedFaculty.length === 0) {
      setError("Please select at least one faculty member.");
      return;
    }

    if (isSubmittingRef.current || submitting) {
      console.log("Submission already in progress, ignoring duplicate call");
      return;
    }

    setSubmitting(true);
    setError(null);
    isSubmittingRef.current = true;

    try {
      const facultyIds = selectedFaculty.map((f) => f.faculty_id);
      const response = await axios.post(
        `${BASE_URL}/event/add-faculty-to-bookslot-new`,
        {
          bookslot_id: bookslotId,
          faculty_ids: facultyIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      const htmlContent = response.data.detail || "Faculty added successfully!";
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      const textContent =
        tempDiv.textContent || tempDiv.innerText || htmlContent;
      alert(textContent.trim());

      setFacultyAdded(true);

      if (onSuccess) {
        onSuccess();
      }
      handleClose();
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
          "Failed to add faculty. Please try again.",
      );
    } finally {
      setSubmitting(false);
      isSubmittingRef.current = false;
    }
  };

  const handleClose = () => {
    if (!submitting) {
      onClose();
      setFacultyCount(1);
      setShowFacultyList(false);
      setPaymentCompleted(false);
      setNeedsPayment(false);
      setSelectedFaculty([]);
      setSearchQuery("");
      setDesignationFilter("");
      setBranchFilter("");
      setError(null);
      setPage(0);
      setShowPaymentPreview(false);
      setPaymentCaptured(false);
      setFacultyAdded(false);
      isSubmittingRef.current = false;
    }
  };

  const clearFilters = () => {
    setSearchQuery("");
    setDesignationFilter("");
    setBranchFilter("");
  };

  const handleAddNewFacultySuccess = () => {
    if (showFacultyList) {
      fetchFacultyList();
    }
    checkPaymentRequirement();
  };

  // Plus/Minus handlers
  const handleIncrement = () => {
    const maxValue = Math.min(
      paymentInfo?.faculty_count_info?.can_pay_for_more || 60,
      60,
    );
    if (facultyCount < maxValue) {
      setFacultyCount(facultyCount + 1);
    }
  };

  const handleDecrement = () => {
    if (facultyCount > 1) {
      setFacultyCount(facultyCount - 1);
    }
  };

  const subTotal =
    paymentInfo?.requires_payment && paymentInfo?.pricing
      ? paymentInfo.pricing.rate_per_faculty * facultyCount
      : 0;
  const gstAmount =
    paymentInfo?.requires_payment && paymentInfo?.pricing
      ? subTotal * (paymentInfo.pricing.gst_percentage / 100)
      : 0;
  const totalAmount = subTotal + gstAmount;

  const facultyCountInfo = paymentInfo?.faculty_count_info;
  const remainingPaidSlots = facultyCountInfo?.remaining_paid_slots || 0;
  const canPayForMore = facultyCountInfo?.can_pay_for_more || 0;

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={showFacultyList ? "lg" : "sm"}
        fullWidth
      >
        <DialogTitle sx={{ py: 1.5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" fontWeight="600">
              Add Faculty Members
            </Typography>
            <IconButton
              onClick={handleClose}
              disabled={submitting}
              size="small"
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ py: 2 }}>
          {checkingPayment ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={6}
            >
              <CircularProgress size={40} />
            </Box>
          ) : (
            <>
              {!showFacultyList &&
                needsPayment &&
                paymentInfo?.requires_payment &&
                paymentInfo?.pricing && (
                  <Box>
                    <Grid container spacing={1.5} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Card
                          elevation={0}
                          sx={{
                            bgcolor: "#1565C0",
                            borderRadius: "10px",
                            p: 1.5,
                            color: "white",
                          }}
                        >
                          <TrendingUp sx={{ fontSize: 24, mb: 0.5 }} />
                          <Typography
                            variant="caption"
                            sx={{ display: "block" }}
                          >
                            Rate per Faculty
                          </Typography>
                          <Typography variant="h6" fontWeight="700">
                            ₹{paymentInfo.pricing.rate_per_faculty.toFixed(2)}
                          </Typography>
                        </Card>
                      </Grid>

                      <Grid item xs={6}>
                        <Card
                          elevation={0}
                          sx={{
                            bgcolor: "#F57C00",
                            borderRadius: "10px",
                            p: 1.5,
                            color: "white",
                          }}
                        >
                          <AccountBalance sx={{ fontSize: 24, mb: 0.5 }} />
                          <Typography
                            variant="caption"
                            sx={{ display: "block" }}
                          >
                            GST Included
                          </Typography>
                          <Typography variant="h6" fontWeight="700">
                            {paymentInfo.pricing.gst_percentage}%
                          </Typography>
                        </Card>
                      </Grid>
                    </Grid>

                    {/* Plus/Minus Counter */}
                    <Card
                      elevation={0}
                      sx={{
                        borderRadius: "10px",
                        p: 2,
                        mb: 2,
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography variant="body2" fontWeight="600" gutterBottom>
                        Faculty Count
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 3,
                          mt: 2,
                        }}
                      >
                        <IconButton
                          onClick={handleDecrement}
                          disabled={facultyCount <= 1}
                          sx={{
                            bgcolor: "#1565C0",
                            color: "white",
                            width: 48,
                            height: 48,
                            "&:hover": {
                              bgcolor: "#0D47A1",
                            },
                            "&:disabled": {
                              bgcolor: "#e0e0e0",
                              color: "#9e9e9e",
                            },
                          }}
                        >
                          <Remove />
                        </IconButton>

                        <Box
                          sx={{
                            minWidth: 100,
                            textAlign: "center",
                            bgcolor: "#E3F2FD",
                            borderRadius: "12px",
                            py: 2,
                            px: 3,
                            border: "2px solid #1565C0",
                          }}
                        >
                          <Typography
                            variant="h4"
                            fontWeight="700"
                            color="#1565C0"
                          >
                            {facultyCount}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Faculty
                          </Typography>
                        </Box>

                        <IconButton
                          onClick={handleIncrement}
                          disabled={facultyCount >= Math.min(canPayForMore, 60)}
                          sx={{
                            bgcolor: "#1565C0",
                            color: "white",
                            width: 48,
                            height: 48,
                            "&:hover": {
                              bgcolor: "#0D47A1",
                            },
                            "&:disabled": {
                              bgcolor: "#e0e0e0",
                              color: "#9e9e9e",
                            },
                          }}
                        >
                          <Add />
                        </IconButton>
                      </Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 2, display: "block", textAlign: "center" }}
                      >
                        You can pay for up to {canPayForMore} faculty slots
                      </Typography>
                    </Card>

                    {/* Cost Breakdown */}
                    <Card
                      elevation={0}
                      sx={{
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <Box sx={{ bgcolor: "#1565C0", p: 1, color: "white" }}>
                        <Typography variant="body2" fontWeight="600">
                          💰 Payment Summary
                        </Typography>
                      </Box>
                      <Box sx={{ p: 1.5 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                            pb: 1,
                            borderBottom: "1px dashed #e0e0e0",
                          }}
                        >
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Subtotal
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {facultyCount} × ₹
                              {paymentInfo.pricing.rate_per_faculty.toFixed(2)}
                            </Typography>
                          </Box>
                          <Typography variant="body1" fontWeight="600">
                            ₹{subTotal.toFixed(2)}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                            pb: 1,
                            borderBottom: "1px dashed #e0e0e0",
                          }}
                        >
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              GST
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {paymentInfo.pricing.gst_percentage}% of subtotal
                            </Typography>
                          </Box>
                          <Typography variant="body1" fontWeight="600">
                            ₹{gstAmount.toFixed(2)}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1.5,
                            borderRadius: "8px",
                            bgcolor: "#E3F2FD",
                          }}
                        >
                          <Box>
                            <Typography variant="body1" fontWeight="700">
                              Total Amount
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <CheckCircle
                                sx={{ fontSize: 14, color: "success.main" }}
                              />
                              <Typography
                                variant="caption"
                                color="success.main"
                                fontWeight="600"
                              >
                                Secure Payment
                              </Typography>
                            </Box>
                          </Box>
                          <Typography
                            variant="h5"
                            fontWeight="700"
                            color="#1565C0"
                          >
                            ₹{totalAmount.toFixed(2)}
                          </Typography>
                        </Box>
                      </Box>
                    </Card>
                  </Box>
                )}

              {showFacultyList && (
                <>
                  {facultyCountInfo && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        mb: 2,
                        gap: 1.5,
                      }}
                    >
                      <Button
                        onClick={() => setShowAddNewFacultyModal(true)}
                        variant="outlined"
                        startIcon={<PersonAdd />}
                        size="small"
                        sx={{
                          borderRadius: "8px",
                          borderColor: "#2E7D32",
                          color: "#2E7D32",
                          "&:hover": {
                            borderColor: "#1B5E20",
                            bgcolor: "rgba(46, 125, 50, 0.04)",
                          },
                        }}
                      >
                        Add New Faculty
                      </Button>

                      {facultyCountInfo.can_pay_for_more > 0 &&
                        paymentInfo?.requires_payment && (
                          <Button
                            variant="contained"
                            onClick={handlePayForMore}
                            startIcon={<Payment />}
                            size="small"
                            sx={{
                              bgcolor: "#F57C00",
                              "&:hover": { bgcolor: "#E65100" },
                              borderRadius: "8px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Pay More
                          </Button>
                        )}
                    </Box>
                  )}

                  {facultyCountInfo && (
                    <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                      <Card
                        elevation={0}
                        sx={{
                          flex: 1,
                          bgcolor: "#E3F2FD",
                          borderRadius: "10px",
                          p: 1.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <Group
                          sx={{
                            fontSize: 32,
                            color: "#1565C0",
                          }}
                        />
                        <Box>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            Total Paid
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight="700"
                            color="#1565C0"
                          >
                            {facultyCountInfo.total_paid_slots}
                          </Typography>
                        </Box>
                      </Card>

                      <Card
                        elevation={0}
                        sx={{
                          flex: 1,
                          bgcolor: "#FFF3E0",
                          borderRadius: "10px",
                          p: 1.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <HowToReg
                          sx={{
                            fontSize: 32,
                            color: "#F57C00",
                          }}
                        />
                        <Box>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            Already Added
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight="700"
                            color="#F57C00"
                          >
                            {facultyCountInfo.faculty_already_added}
                          </Typography>
                        </Box>
                      </Card>

                      <Card
                        elevation={0}
                        sx={{
                          flex: 1,
                          bgcolor: "#E8F5E9",
                          borderRadius: "10px",
                          p: 1.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}
                      >
                        <CheckCircleOutline
                          sx={{
                            fontSize: 32,
                            color: "#2E7D32",
                          }}
                        />
                        <Box>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            Available
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight="700"
                            color="#2E7D32"
                          >
                            {facultyCountInfo.remaining_paid_slots}
                          </Typography>
                        </Box>
                      </Card>
                    </Box>
                  )}

                  {paymentCompleted && (
                    <Alert
                      severity="success"
                      icon={<CheckCircle />}
                      sx={{ mb: 2, borderRadius: "12px" }}
                    >
                      ✓ Payment successful! You can now select faculty members
                      from the list below.
                    </Alert>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mb: 2,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      placeholder="Search by name, email or phone"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      size="small"
                      sx={{ flexGrow: 1, minWidth: "250px" }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Designation</InputLabel>
                      <Select
                        value={designationFilter}
                        onChange={(e) => setDesignationFilter(e.target.value)}
                        label="Designation"
                      >
                        <MenuItem value="">All</MenuItem>
                        {uniqueDesignations.map((designation) => (
                          <MenuItem key={designation} value={designation}>
                            {designation}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Branch</InputLabel>
                      <Select
                        value={branchFilter}
                        onChange={(e) => setBranchFilter(e.target.value)}
                        label="Branch"
                      >
                        <MenuItem value="">All</MenuItem>
                        {uniqueBranches.map((branch) => (
                          <MenuItem key={branch} value={branch}>
                            {branch}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {(searchQuery || designationFilter || branchFilter) && (
                      <Button onClick={clearFilters} size="small">
                        Clear Filters
                      </Button>
                    )}
                  </Box>

                  {selectedFaculty.length > 0 && (
                    <Chip
                      label={`${selectedFaculty.length} ${remainingPaidSlots > 0 ? `of ${remainingPaidSlots}` : ""} selected`}
                      color="primary"
                      sx={{ mb: 2 }}
                    />
                  )}

                  {error && (
                    <Alert
                      severity="error"
                      onClose={() => setError(null)}
                      sx={{ mb: 2 }}
                    >
                      {error}
                    </Alert>
                  )}

                  {loading ? (
                    <Box>
                      {[1, 2, 3, 4, 5].map((item) => (
                        <Skeleton key={item} height={60} sx={{ mb: 1 }} />
                      ))}
                    </Box>
                  ) : (
                    <>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell padding="checkbox">
                                <Checkbox
                                  indeterminate={
                                    selectedFaculty.length > 0 &&
                                    !isAllSelected()
                                  }
                                  checked={isAllSelected()}
                                  onChange={handleSelectAll}
                                  disabled={paginatedFaculty().length === 0}
                                />
                              </TableCell>
                              <TableCell>Name</TableCell>
                              <TableCell>Email</TableCell>
                              <TableCell>Phone</TableCell>
                              <TableCell>Designation</TableCell>
                              <TableCell>Branch</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {paginatedFaculty().length > 0 ? (
                              paginatedFaculty().map((faculty, index) => (
                                <TableRow
                                  key={`${faculty.faculty_id}-${faculty.email}-${index}`}
                                  hover
                                  onClick={() => handleSelectFaculty(faculty)}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={isFacultySelected(faculty)}
                                      onChange={() =>
                                        handleSelectFaculty(faculty)
                                      }
                                    />
                                  </TableCell>
                                  <TableCell>{faculty.name}</TableCell>
                                  <TableCell>{faculty.email}</TableCell>
                                  <TableCell>{faculty.phone_no}</TableCell>
                                  <TableCell>
                                    {faculty.designation || "-"}
                                  </TableCell>
                                  <TableCell>{faculty.branch || "-"}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6} align="center">
                                  {filteredFacultyList.length === 0
                                    ? searchQuery ||
                                      designationFilter ||
                                      branchFilter
                                      ? "No faculty found matching your filters"
                                      : "No faculty available"
                                    : "No results"}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        component="div"
                        count={filteredFacultyList.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleClose}
            disabled={submitting}
            variant="outlined"
            size="small"
            sx={{ borderRadius: "8px" }}
          >
            Cancel
          </Button>

          {!showFacultyList && needsPayment ? (
            <Button
              onClick={handleShowPaymentPreview}
              variant="contained"
              disabled={submitting || facultyCount < 1}
              size="small"
              sx={{
                borderRadius: "8px",
                bgcolor: "#1565C0",
                px: 2,
                "&:hover": { bgcolor: "#0D47A1" },
              }}
            >
              Continue to Payment →
            </Button>
          ) : showFacultyList ? (
            <Button
              onClick={handleAddFacultyToBookslot}
              variant="contained"
              disabled={submitting || selectedFaculty.length === 0}
              startIcon={
                submitting ? <CircularProgress size={16} /> : <PersonAdd />
              }
              size="small"
              sx={{
                borderRadius: "8px",
                bgcolor: "#1565C0",
                "&:hover": { bgcolor: "#0D47A1" },
              }}
            >
              {submitting
                ? "Processing..."
                : `Add ${selectedFaculty.length > 0 ? `(${selectedFaculty.length})` : ""} Faculty`}
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>

      <PaymentPreviewModal
        open={showPaymentPreview}
        onClose={() => !submitting && setShowPaymentPreview(false)}
        onConfirm={handlePaymentFlow}
        paymentData={paymentInfo}
        facultyCount={facultyCount}
        loading={submitting}
      />

      <AddNewFacultyModal
        open={showAddNewFacultyModal}
        onClose={() => setShowAddNewFacultyModal(false)}
        bookslotId={bookslotId}
        onSuccess={handleAddNewFacultySuccess}
      />
    </>
  );
};

export default AddFacultyModal;
